import useWindowSize from "@/hooks/useWindowSize";
import { useScroll } from "framer-motion";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import breakpoints from "@/constants/breakpoinst";

export default function ScrollHiderWrapper({
  children,
  offset = 100,
  scrollYAmount = 0,
  className: style,
}) {
  const getYAmount = () => {
    if (windosSize.width >= breakpoints.lg) {
      return -80;
    } else if (windosSize.width >= breakpoints.md) {
      return -50;
    } else if (windosSize.width <= breakpoints.lg) {
      return -50;
    }
  };
  const windosSize = useWindowSize();
  const fadeAnimation = {
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
    hidden: { y: getYAmount(), opacity: 1, transition: { duration: 0.5 } },
  };
  const { scrollY } = useScroll();
  const [hide, setHide] = useState(false);
  const [posBehave, setPosBehave] = useState("fixed");
  const checkPosition = () => {
    if (scrollY?.current < scrollY?.prev) {
      setHide(false);
    } else if (scrollY?.current > offset && scrollY?.current > scrollY?.prev) {
      setHide(true);
      setPosBehave("fixed shadow-md");
    }
    if (scrollY?.current === 0) {
      setPosBehave("fixed");
    }
  };

  useEffect(() => {
    return scrollY.onChange(() => checkPosition());
  });

  // this code was for different behavoir on desktop, but it is no longer needed, just here for reference
  // const className = twMerge(`md:hidden z-10 ${posBehave} top-0 w-full`, style);
  const className = twMerge(`z-10 ${posBehave} top-0 w-full`, style);

  return (
    <>
      <motion.div
        className={className}
        variants={fadeAnimation}
        animate={hide ? "hidden" : "visible"}
      >
        {children}
      </motion.div>

      {/*
      this code was for different behavoir on desktop, but it is no longer needed
      <motion.div
        className="top-0 border-b-2 sm:hidden md:block"
        variants={fadeAnimation}
        animate={hide ? "hidden" : "visible"}
      >
        {children}
      </motion.div> */}
    </>
  );
}
